export default {
  /**
   * 分類条件の標準フォーマット
   */
  get() {
    return {
      /**
       * @see store.js
       */
      key: new Date().getTime().toString(),
      /**
       * 企業コード
       */
      company: undefined,
      /**
       * 分類階層
       */
      itemCategoryLevel: undefined,
      /**
       * 選択分類
       */
      categories: [],
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する分類のフォーマットに変換する
   */
  mapToApiPayload(category) {
    return {
      company: category.company,
      itemCategoryLevel: category.itemCategoryLevel,
      categories: category.categories,
    }
  },
  /**
   * applyToに対してcategoryを適用する
   */
  applyPayload(applyTo, category) {
    applyTo.key = new Date().getTime().toString()
    applyTo.company = category.company
    applyTo.itemCategoryLevel = category.itemCategoryLevel
    applyTo.categories = category.categories
  },
}
